import { useEffect, useMemo, useState } from "react";
import AscTable from "../AscTable";
import AscButton from "../../AscButton/AscButton";
import { CheckboxInp } from "./AscCustomCheckBox/CheckboxInp";
import { MoreIcon } from "../../AscIcons";
import classNames from "classnames";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import styles from "./AscAdminJournalTable.module.scss";

export interface AscAdminJournalTableProps {
  studentsData: any;
  openJournal?: () => void;
  onClickEdit?: (id: any) => void;
  onClickRemove?: () => void;
  onClickFilter?: () => void;
}

export enum StudentListEnum {
  id = "id",
  genCheck = "genCheck",
  name = "name",
  parentEmail = "parentEmail",
  completion = "completion",
  email = "email",
  schoolRank = "schoolRank",
  globalRank = "globalRank",
  batch = "batch",
  status = "status",
  genCheckMain = "genCheckMain",
  grade = "grade",
  timeOnPlatform = "timeOnPlatform",
  report = "report",
  journal = "journal",
  action = "action",
}

export type FilterFnOfTableT = (
  rows: {
    allCells: any[];
    cells: any[];
    depth: number;
    id: string;
    index: number;
    original: { [key: string]: any };
    values: { [key: string]: any };
  }[],
  columnIds: string[],
  filterValue: any
) => any[];

export interface IMyColumn {
  Header: any;
  accessor: string;
  Cell?: any;

  filter?: FilterFnOfTableT;
}

export default function AscAdminJournalTable({
  studentsData,
  openJournal,
  onClickEdit,
  onClickRemove,
  onClickFilter,
}: AscAdminJournalTableProps) {
  const tableData: {
    [StudentListEnum.id]: any;
    [StudentListEnum.genCheck]: boolean;
    [StudentListEnum.name]: string;
    [StudentListEnum.parentEmail]: string;
    [StudentListEnum.completion]: string;
    [StudentListEnum.email]: string;
    [StudentListEnum.schoolRank]: string;
    [StudentListEnum.globalRank]: string;
    [StudentListEnum.batch]: string;
    [StudentListEnum.status]: string;
    [StudentListEnum.grade]: string;
    [StudentListEnum.timeOnPlatform]: string;
    [StudentListEnum.journal]: string;
    [StudentListEnum.action]: string;
  }[] = useMemo(() => [...studentsData], [studentsData]);

  const [mainGenCheckbox, setMainGenCheckbox] = useState<boolean>(() => {
    const boo = tableData.some((x) => x.genCheck !== true);
    const allRowsSelected = boo === false;

    return allRowsSelected;
  });

  const [genCheckForEachRow, setGenCheckForEachRow] = useState<boolean[]>(
    () => {
      const arr = tableData.map((x) => x.genCheck);
      return arr;
    }
  );

  const [partPayCheckboxForEachRow, setPartPayCheckboxForEachRow] = useState<
    any[]
  >(() => {
    const arr = tableData.map((x) => x.batch);
    return arr;
  });

  useEffect(() => {
    const boo = genCheckForEachRow.some((x) => x !== true);
    const allRowsSelected = boo === false;
    setMainGenCheckbox(allRowsSelected);
  }, [genCheckForEachRow]);

  const tableColumns = useMemo(() => {
    const columns = [
      {
        Header: (
          <CheckboxInp
            id={StudentListEnum.genCheckMain}
            name={StudentListEnum.genCheckMain}
            onBlur={() => 0}
            isChecked={mainGenCheckbox}
            textualValue={StudentListEnum.genCheckMain}
            tryToChange={(change) => {
              setGenCheckForEachRow((prev) =>
                prev.map((_x) => change.isChecked || false)
              );
            }}
            className={styles.genCheckMain}
          />
        ),
        accessor: StudentListEnum.genCheck,

        Cell: (cell: { row: { index: any } }) => {
          const ind = cell.row.index;
          const nm = `${StudentListEnum.genCheck}${ind}`;

          return (
            <CheckboxInp
              // type={"checkbox"}
              id={nm}
              // label={""}
              name={nm}
              onBlur={() => 0}
              isChecked={genCheckForEachRow[ind]}
              // value={String(ind)}
              // setFieldValue={() => 0}
              textualValue={String(ind)}
              tryToChange={(change) => {
                setGenCheckForEachRow((prev) =>
                  prev.map((x, i) => {
                    if (ind === i) {
                      return change.isChecked || false;
                    }
                    return x;
                  })
                );

                if (!change.isChecked && partPayCheckboxForEachRow[ind]) {
                  setPartPayCheckboxForEachRow((prev) =>
                    prev.map((x, i) => {
                      if (ind === i) {
                        return change.isChecked || false;
                      }
                      return x;
                    })
                  );
                }
              }}
              className={styles.coolCheck}
            />
            // <CheckboxInp
            //   id={nm}
            //   name={nm}
            //   onBlur={() => 0}
            //   isChecked={genCheckForEachRow[ind]}
            //   textualValue={String(ind)}
            //   tryToChange={(change) => {
            //     setGenCheckForEachRow((prev) =>
            //       prev.map((x, i) => {
            //         if (ind === i) {
            //           return change.isChecked || false;
            //         }
            //         return x;
            //       })
            //     );
            //   }}
            //   className={styles.coolCheck}
            // />
          );
        },
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Name"}</div>;
        },
        accessor: StudentListEnum.name,
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Email"}</div>;
        },
        accessor: StudentListEnum.email,
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Batch"}</div>;
        },
        accessor: StudentListEnum.batch,
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Journal"}</div>;
        },
        accessor: StudentListEnum.journal,

        Cell: () => {
          return (
            <AscButton
              onClick={openJournal}
              className={styles.button}
              size="small"
            >
              Open Journal
            </AscButton>
          );
        },
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Status"}</div>;
        },
        accessor: StudentListEnum.status,

        Cell: (cell: { value: any }) => {
          if (cell.value === "Error") {
            return (
              <p className={classNames(styles.status, styles.error)}>Error</p>
            );
          } else if (cell.value === "Active") {
            return (
              <p className={classNames(styles.status, styles.active)}>Active</p>
            );
          } else {
            return (
              <p className={classNames(styles.status, styles.invited)}>
                Invited
              </p>
            );
          }
        },
      },

      {
        Header: () => {
          return <div className={styles.header}>{"Action"}</div>;
        },
        accessor: StudentListEnum.action,

        Cell: (props: any) => {
          const { id } = props.cell.row.original;

          return (
            <Action
              id={id}
              onClickEdit={(id: any) => onClickEdit}
              onClickRemove={onClickRemove}
              onClickFilter={onClickFilter}
            />
          );
        },
      },
    ];

    return columns;
  }, [
    genCheckForEachRow,
    mainGenCheckbox,
    openJournal,
    partPayCheckboxForEachRow,
  ]);

  return (
    <div className={styles.table}>
      <span className={styles.title}>Students list</span>

      <AscTable
        tHead={styles.tHead}
        myTable={styles.myTable}
        tHeadRow={styles.tHeadRow}
        tH={styles.tH}
        tBody={styles.tBody}
        tRow={styles.tRow}
        pureCellFlow={styles.pureCellFlow}
        tD={styles.tD}
        tBodyValue={styles.tBodyValue}
        tableColumns={tableColumns}
        tableData={tableData}
        showHeader={true}
      />
    </div>
  );
}

export interface ActionProps {
  id?: any;
  onClickEdit?: any;
  onClickRemove?: any;
  onClickFilter?: any;
}

const Action = ({
  onClickEdit,
  onClickRemove,
  onClickFilter,
  id,
}: ActionProps) => {
  const [showAction, setShowAction] = useState<boolean>(false);
  const [activeId, setActiveId] = useState();

  const handleClick = () => {
    setShowAction(!showAction);
    setActiveId(id);
  };

  return (
    <div>
      <div onClick={handleClick}>
        <MoreIcon className={styles.moreIcon} />
      </div>

      {showAction === true && (
        <AscAdminAction
          className={styles.action}
          option1="Edit"
          option2="Remove"
          option3="Filter item"
          clickOption1={onClickEdit}
          clickOption2={onClickRemove}
          clickOption3={onClickFilter}
        />
      )}
    </div>
  );
};
